import * as React from 'react'

import './app_store_links.scss'
import NavigationItem from '../navigation_item/navigation_item'
import { APP_STORE_PATH, GOOGLE_PLAY_PATH } from '../../constants/urls'
import * as googlePlayButton from './google_play_button.svg'
import * as appStoreButton from './app_store_button.svg'

import { CLASS_PREFIX } from '../../constants'

const cls = CLASS_PREFIX + 'app-store-links'

// A missing, empty or blank URL counts as not set.
const linkIfSet = (url: unknown): string | undefined =>
  typeof url === 'string' ? url.trim() || undefined : undefined

export const hasAnyAppStoreLink = (): boolean =>
  !!linkIfSet(GOOGLE_PLAY_PATH) || !!linkIfSet(APP_STORE_PATH)

const AppStoreLinks: React.FC = () => {
  const googlePlayLink = linkIfSet(GOOGLE_PLAY_PATH)
  const appStoreLink = linkIfSet(APP_STORE_PATH)

  if (!googlePlayLink && !appStoreLink) {
    return null
  }

  return (
    <div className={cls}>
      {googlePlayLink && (
        <div className={'google-play-button'}>
          <NavigationItem url={googlePlayLink} target='_blank'>
            <img alt='Google Play Store' src={googlePlayButton} />
          </NavigationItem>
        </div>
      )}
      {appStoreLink && (
        <div className={'apple-play-button'}>
          <NavigationItem url={appStoreLink} target='_blank'>
            <img alt='App Store' src={appStoreButton}/>
          </NavigationItem>
        </div>
      )}
    </div>
  )
}

export default AppStoreLinks
